/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Review_Titleminlength2Inputs */

const id_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Judul harus minimal 3 karakter`)
};

const ms_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tajuk mesti sekurang-kurangnya 3 aksara`)
};

const da_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel skal være mindst 3 tegn`)
};

const de_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Titel muss mindestens 3 Zeichen lang sein`)
};

const en_us2_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title must be at least 3 characters`)
};

const es_es2_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El título debe tener al menos 3 caracteres`)
};

const es_mx2_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El título debe tener al menos 3 caracteres`)
};

const fil_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ang pamagat ay dapat na hindi bababa sa 3 character`)
};

const fr_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le titre doit contenir au moins 3 caractères`)
};

const it_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il titolo deve avere almeno 3 caratteri`)
};

const hu_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A címnek legalább 3 karakter hosszúnak kell lennie`)
};

const nl_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titel moet ten minste 3 tekens bevatten`)
};

const no_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tittelen må være minst 3 tegn`)
};

const pl_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tytuł musi mieć co najmniej 3 znaki`)
};

const pt_br2_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title must be at least 3 characters`)
};

const pt_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O título deve ter pelo menos 3 caracteres`)
};

const ro_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titlul trebuie să aibă cel puțin 3 caractere`)
};

const fi_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otsikon on oltava vähintään 3 merkkiä`)
};

const sv_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titeln måste vara minst 3 tecken`)
};

const vi_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiêu đề phải có ít nhất 3 ký tự`)
};

const tr_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlık en az 3 karakter olmalıdır`)
};

const cs_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Název musí mít alespoň 3 znaky`)
};

const bg_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заглавието трябва да е най-малко 3 знака`)
};

const ru_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заголовок должен содержать не менее 3 символов`)
};

const uk_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заголовок має містити щонайменше 3 символи`)
};

const ar_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يجب أن يحتوي العنوان على 3 أحرف على الأقل`)
};

const hi_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शीर्षक कम से कम 3 अक्षर`)
};

const th_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ชื่อเรื่องต้องมีอย่างน้อย 3 ตัวอักษร`)
};

const ja_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトルは3文字以上である必要があります`)
};

const zh_cn2_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title must be at least 3 characters`)
};

const zh_hant1_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title must be at least 3 characters`)
};

const ko_forms_review_titleminlength2 = /** @type {(inputs: Forms_Review_Titleminlength2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Title must be at least 3 characters`)
};

/**
* | output |
* | --- |
* | "Title must be at least 3 characters" |
*
* @param {Forms_Review_Titleminlength2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const forms_review_titleminlength2 = /** @type {((inputs?: Forms_Review_Titleminlength2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Review_Titleminlength2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_forms_review_titleminlength2(inputs)
	if (locale === "ms") return ms_forms_review_titleminlength2(inputs)
	if (locale === "da") return da_forms_review_titleminlength2(inputs)
	if (locale === "de") return de_forms_review_titleminlength2(inputs)
	if (locale === "en-US") return en_us2_forms_review_titleminlength2(inputs)
	if (locale === "es-ES") return es_es2_forms_review_titleminlength2(inputs)
	if (locale === "es-MX") return es_mx2_forms_review_titleminlength2(inputs)
	if (locale === "fil") return fil_forms_review_titleminlength2(inputs)
	if (locale === "fr") return fr_forms_review_titleminlength2(inputs)
	if (locale === "it") return it_forms_review_titleminlength2(inputs)
	if (locale === "hu") return hu_forms_review_titleminlength2(inputs)
	if (locale === "nl") return nl_forms_review_titleminlength2(inputs)
	if (locale === "no") return no_forms_review_titleminlength2(inputs)
	if (locale === "pl") return pl_forms_review_titleminlength2(inputs)
	if (locale === "pt-BR") return pt_br2_forms_review_titleminlength2(inputs)
	if (locale === "pt") return pt_forms_review_titleminlength2(inputs)
	if (locale === "ro") return ro_forms_review_titleminlength2(inputs)
	if (locale === "fi") return fi_forms_review_titleminlength2(inputs)
	if (locale === "sv") return sv_forms_review_titleminlength2(inputs)
	if (locale === "vi") return vi_forms_review_titleminlength2(inputs)
	if (locale === "tr") return tr_forms_review_titleminlength2(inputs)
	if (locale === "cs") return cs_forms_review_titleminlength2(inputs)
	if (locale === "bg") return bg_forms_review_titleminlength2(inputs)
	if (locale === "ru") return ru_forms_review_titleminlength2(inputs)
	if (locale === "uk") return uk_forms_review_titleminlength2(inputs)
	if (locale === "ar") return ar_forms_review_titleminlength2(inputs)
	if (locale === "hi") return hi_forms_review_titleminlength2(inputs)
	if (locale === "th") return th_forms_review_titleminlength2(inputs)
	if (locale === "ja") return ja_forms_review_titleminlength2(inputs)
	if (locale === "zh-CN") return zh_cn2_forms_review_titleminlength2(inputs)
	if (locale === "zh-Hant") return zh_hant1_forms_review_titleminlength2(inputs)
	return ko_forms_review_titleminlength2(inputs)
});
export { forms_review_titleminlength2 as "forms.review.titleMinLength" }